import Box from "@mui/material/Box";
import { useTranslation } from "@privacy/translations";
import type { RegistrationStatus } from "../api/registrations.types";
import { RegistrationStatusDot } from "./RegistrationStatusDot";

const StatusWord = ({ status }: { status: RegistrationStatus["status"] }) => {
  const { t } = useTranslation();

  return (
    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 1, whiteSpace: "nowrap" }}>
      <RegistrationStatusDot status={status} />
      {t(`RegistrationStatus.${status}`)}
    </Box>
  );
};

export const STATUS_WORDS = {
  draft: <StatusWord status="draft" />,
  review: <StatusWord status="review" />,
  completion: <StatusWord status="completion" />,
  done: <StatusWord status="done" />,
  audit: <StatusWord status="audit" />,
};
